import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { 
  AlertTriangle, 
  AlertOctagon, 
  Receipt, 
  ChevronRight,
  X
} from 'lucide-react';
import { Button } from '../components/ui/button';
import { Card, CardContent } from '../components/ui/card';

const IncidentQuestionnaireBanner = ({ onDismiss }) => {
  const navigate = useNavigate();
  const [dismissed, setDismissed] = useState(false);

  if (dismissed) return null;

  const handleDismiss = () => {
    setDismissed(true);
    if (onDismiss) onDismiss();
  };

  const questions = [
    {
      icon: AlertTriangle,
      question: "Was there a breakdown?",
      color: "amber",
      bgColor: "bg-amber-50",
      iconColor: "text-amber-600",
      borderColor: "border-amber-200",
      buttonColor: "bg-amber-600 hover:bg-amber-700",
      path: "/breakdowns",
      action: "Report Breakdown"
    },
    {
      icon: AlertOctagon,
      question: "Was there an accident?",
      color: "red",
      bgColor: "bg-red-50",
      iconColor: "text-red-600",
      borderColor: "border-red-200",
      buttonColor: "bg-red-600 hover:bg-red-700",
      path: "/accidents",
      action: "Report Accident"
    },
    {
      icon: Receipt,
      question: "Were there any fines?",
      color: "blue",
      bgColor: "bg-blue-50",
      iconColor: "text-blue-600",
      borderColor: "border-blue-200",
      buttonColor: "bg-blue-600 hover:bg-blue-700",
      path: "/fines",
      action: "Report Fine"
    }
  ];

  return (
    <Card className="border-2 border-slate-200 shadow-lg mb-6" data-testid="incident-questionnaire-banner">
      <CardContent className="p-4">
        <div className="flex items-center justify-between mb-4">
          <h3 className="font-semibold text-lg text-slate-800">Daily Incident Check</h3>
          <Button 
            variant="ghost" 
            size="sm" 
            onClick={handleDismiss}
            className="text-slate-400 hover:text-slate-600"
          >
            <X className="w-4 h-4" />
          </Button>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          {questions.map((item, index) => {
            const Icon = item.icon;
            return (
              <div 
                key={index}
                className={`${item.bgColor} ${item.borderColor} border rounded-lg p-4 flex flex-col items-center text-center space-y-3`}
              >
                <div className={`w-12 h-12 rounded-full ${item.bgColor} flex items-center justify-center`}>
                  <Icon className={`w-6 h-6 ${item.iconColor}`} />
                </div>
                <p className="font-medium text-slate-700">{item.question}</p>
                <Button 
                  className={`${item.buttonColor} text-white w-full gap-1`}
                  onClick={() => navigate(item.path)}
                >
                  {item.action}
                  <ChevronRight className="w-4 h-4" />
                </Button>
              </div>
            );
          })}
        </div>
      </CardContent>
    </Card>
  );
};

export default IncidentQuestionnaireBanner;
